import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ICommand } from './command/command.models';
import { ITaskCommandWrapper, ITaskHost } from './task.state.models';

export class TaskHostDefault implements ITaskHost {

    private _commands$ = new BehaviorSubject<ITaskCommandWrapper[]>(null);
    commands$ = this._commands$.asObservable();
    get commandsSync() {
        return this.commands$ && this._commands$.value;
    }

    commandHostReady$ = this.commands$.pipe(map(_ => _ != null && _.length > 0));

    private _trackingCommands$ = new BehaviorSubject<ICommand[]>([]);
    get trackingCommandsSync(): ICommand[] {
        return this._trackingCommands$.value;
    }
    trackingCommands$: Observable<ICommand[]> = this._trackingCommands$.asObservable();
    executingCommandParse: any;

    async tryNextCommand(): Promise<void> {
        this._commands$.next(this.commandsSync)
    }

    runCommands(commands: ICommand[]): void {
        // clean track commands list
        this._trackingCommands$.next([]);
        this._commands$.next(commands.map(_ => _ as ITaskCommandWrapper));
    }

    updateTrackingCommand(cmd: ICommand) {
        const index = this.trackingCommandsSync.findIndex(cmdItem => cmd.id === cmdItem.id);
        if (index >= 0) {
            this.trackingCommandsSync.splice(index, 1, cmd);
        }
    }

    setTrackingCommands(commands: ICommand[]) {
        this._trackingCommands$.next(commands);
    }
}
